<template>
  <div
    v-if="selectedCompany.Location"
    :style="showNewUi ? 'background-color : #F6F6F6' : alertStyle"
    class="alert p-2 mt-2 alert-color"
    role="alert"
  >
    <h3 :class="!showNewUi && 'font-weight-bold'  " :style="showNewUi && 'font-weight : 600; color : #151515; font-size:18px '" class=" pr-2">{{ $t("message.pickUpFrom") }}</h3>
    <div class="row" >
      <div class="col-sm-9" :style="showNewUi && 'font-weight: normal; font-size: 13px'">
        <p class="mb-1">{{ selectedCompany.Name }}</p>
        <p class="mb-1" :class="showNewUi && 'mt-2'">{{ selectedCompany.Location.Address }}</p>
        <p class="mb-1"  :class="showNewUi && 'mt-2'">{{ selectedCompany.Location.State }}, {{ selectedCompany.Location.Suburb }}</p>
      </div>
      <div class="col-sm-3">
        <img
          v-if="!isRolldStore()"
          alt="view in google map"
          class="google-map-img"
          title="Direction"
          :src="googlemapImg"
          @click="GoGoogleMap"
        />
      </div>
    </div>
  </div>
</template>

<script>
import googlemap from "./../../../../assets/google-maps.png";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["mobileStyles", "desktopStyles", "selectedCompany", "viewConfig"]),
    googlemapImg() {
      return googlemap;
    },
    alertStyle() {
      return this.isMobile()
        ? this.mobileStyles.primaryBodyBackground
        : this.desktopStyles.primaryBodyBackground;
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    }
  },

  methods: {
    GoGoogleMap() {
      if (this.selectedCompany.Location.Address) {
        var address =
          this.selectedCompany.Location.Address +
          ", " +
          (this.selectedCompany.Location.Suburb
            ? this.selectedCompany.Location.Suburb
            : "") +
          " " +
          (this.selectedCompany.Location.State
            ? this.selectedCompany.Location.State
            : "") +
          " " +
          (this.selectedCompany.Location.Postcode
            ? this.selectedCompany.Location.Postcode
            : "") +
          ", " +
          (this.selectedCompany.Location.Country
            ? this.selectedCompany.Location.Country
            : "");
        var url = "http://www.google.com/maps/place/" + address;
        window.open(url);
      }
    }
  }
};
</script>
